module.exports = __webpack_public_path__ + "media/v.26add973.mp4";